<template>
  <section style="margin: 2em 0;">
    <h3>Candidate Finances</h3>

    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      :dense="mobile"
      :hide-default-footer="true">

      <template #item.name="{item}">
        <a
          v-if="item.link.length"
          :href="item.link"
          target="_blank">
          {{ item.name }}
        </a>

        <span v-else>{{ item.name }}</span>

        <br/>

        <span class="party">({{ item.party }})</span>
      </template>

      <template #item.cashOnHand="{item}">
        ${{ item.cashOnHand | commas }}
      </template>

      <template #item.contributions="{item}">
        ${{ item.contributions | commas }}
      </template>

      <template #item.disbursements="{item}">
        ${{ item.disbursements | commas }}
      </template>

      <template #item.date="{item}">
        {{ item.date | date }}
      </template>
    </v-data-table>

    <p class="legend">CoH = Cash on Hand</p>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

const props = {
  tableItems: {
    default: [],
    required: true,
    type: Array,
  },
};

const computed = {
  ...mapGetters({
    mobile: "ux/mobile",
  }),
};

export default {
  props,
  computed,
  data: () => ({
    tableHeaders: [
      {
        align: "start",
        text: "Candidate",
        value: "name",
      },
      {
        text: "CoH",
        value: "cashOnHand",
      },
      {
        text: "Contributions",
        value: "contributions",
      },
      {
        text: "Disbursements",
        value: "disbursements",
      },
      {
        text: "Report",
        value: "report",
      },
      {
        align: "end",
        text: "Date",
        value: "date",
      },
    ],
  }),
};
</script>

<style scoped>
h3 {
  margin: 1em 0;
}

.party,
.legend {
  font-size: .85rem;
  font-weight: 300;
}

.legend {
  font-style: italic;
  text-align: right;
}

.v-data-table /deep/ td {
  min-height: 2.5em;
}
</style>
